import Token from './token'
import Form from './form'

export default {
  svg: 'bell',
  label: 'Send Notification',
  type: 'administrative',
  action: 'notification',
  form: Form,
  token: Token
}
